module.exports = __webpack_public_path__ + "media/images/sample-client-image-c64b9e101279f2e0870fe4fc59747fe6.png";